import { deepmerge } from "@mui/utils";
import { PageHeroSlotProps } from "../common/page-hero/page-hero";

const baseVideoSectionSlotProps: PageHeroSlotProps = {
  heroHeader: {
    sx: {
      fontSize: "2.8rem",
      fontWeight: "600",
      color: "text.primary",
      marginBottom: "2.4rem"
    }
  },
  sectionHeader: {
    copySx: {
      fontSize: "1.6rem !important",
      textAlign: { xs: "center", lg: "inherit" }
    }
  },
  contentContainer: {
    sx: {
      flexDirection: {
        xs: "column-reverse",
        sm: "column-reverse",
        md: "column-reverse"
      }
    }
  },
  textContent: {
    sx: {
      maxWidth: "100%",
      textAlign: { xs: "center", lg: "inherit" },
      height: "stretch",
      alignContent: "center"
    }
  },
  mediaContainer: {
    sx: {
      width: {
        xs: "342px",
        sm: "514px"
      },
      maxWidth: {
        xs: "100%",
        md: "514px"
      },
      margin: {
        xs: "0 auto",
        md: "0 auto",
        lg: "0"
      }
    }
  }
};

const createVideoSectionSlotProps = (
  overrides: PageHeroSlotProps = {}
): PageHeroSlotProps => deepmerge(baseVideoSectionSlotProps, overrides);

export default createVideoSectionSlotProps;
